import type { TableView } from 'owa-mail-list-store';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Baseline. Do not copy and paste"
 *	> '../index' import is restricted from being used. */
import { lazyLoadMoreInTable, getCanTableLoadMore } from '../index';
import { INITIAL_LOAD_ROW_COUNT } from 'owa-mail-triage-common';

/**
 * Returns flag indicating whether we should try to load more in the given table on row remove
 * @param tableView where row is removed
 */
function shouldLoadMoreOnRowRemove(tableView: TableView): boolean {
    return (
        tableView.rowKeys.length < INITIAL_LOAD_ROW_COUNT &&
        !tableView.isLoading &&
        getCanTableLoadMore(tableView)
    );
}

/** Try loading more in table when after row removal
 * @param tableView where row is removed
 */
export function tryLoadMoreUponRowRemove(tableView: TableView): void {
    // Loading of more rows should be done asynchronously
    // We must check shouldLoadMoreOnRowRemove again after setTimeout
    if (shouldLoadMoreOnRowRemove(tableView)) {
        lazyLoadMoreInTable.importAndExecute(tableView);
    }
}
